module.exports = __webpack_public_path__ + "static/media/instagram.b0f82241.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_minha-central/Footer/social-icons/instagram.svg
// module id = 1437
// module chunks = 0